import { getApiUrl, getRelativeUrl } from "../../utils/urlHelper.js";

export const getBrowserSafeUrl = (urlStr) => {
  if (!urlStr) return "";
  let safeUrl = urlStr;
  const rawPattern = /\.(heic|heif|cr3|arw|nef|cr2|raw)$/i;
  if (rawPattern.test(safeUrl)) {
    safeUrl = safeUrl.replace(rawPattern, ".jpg");
  }
  return getApiUrl(getRelativeUrl(safeUrl));
};

export const getThumbUrl = (photo) => {
  if (photo?.thumbnailPath) return getBrowserSafeUrl(photo.thumbnailPath);
  if (!photo?.filePath) return "";
  const relative = getRelativeUrl(photo.filePath);
  const base = (typeof process !== "undefined" && process.env?.REACT_APP_API_URL) || "";
  return `${base}/img${relative}?w=400&fmt=webp`;
};

export const getPreviewUrl = (photo) => {
  if (photo?.previewPath) return getBrowserSafeUrl(photo.previewPath);
  if (!photo?.filePath) return "";
  const relative = getRelativeUrl(photo.filePath);
  const base = (typeof process !== "undefined" && process.env?.REACT_APP_API_URL) || "";
  return `${base}/img${relative}?w=1920&fmt=webp`;
};
